export default "__VITE_ASSET__DEXiLrWH__"